import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import GlobalStyles from 'src/components/GlobalStyles';
import theme from 'src/theme';
import routes from 'src/routes';
import moment from "moment";
import MomentUtils from '@date-io/moment';

import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { AuthProvider } from './services/context';
import 'moment/locale/pt-br';

const locale = "pt-br";
moment.locale(locale);


const App = () => {
  const routing = useRoutes(routes);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={locale}>
          <GlobalStyles />
          {routing}
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
